import { configureStore } from "@reduxjs/toolkit";
import { RootReducer } from "./reducers";

const store = configureStore({
  reducer: RootReducer,
  devTools: true,
});

export default store;
